import type { StatusTone } from '@/components/status-badge';

const time = (date: Date) =>
  date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
const day = (date: Date) => date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

/** "2h10", "35 min": quanto falta até o corte, no tamanho que o operador lê de relance. */
export function timeLeft(from: Date, to: Date): string {
  const minutes = Math.max(0, Math.round((to.getTime() - from.getTime()) / 60_000));
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest === 0 ? `${hours}h` : `${hours}h${String(rest).padStart(2, '0')}`;
}

/**
 * Como mostrar o horário de corte de um pacote a enviar: passou (vermelho), hoje (amarelo, com o
 * tempo que falta), amanhã, ou a data. No fuso de quem olha — é o relógio da pessoa que despacha.
 */
export function shipByLabel(
  iso: string,
  now: Date = new Date(),
): { tone: StatusTone; label: string; detail?: string } {
  const deadline = new Date(iso);
  const days = Math.round(
    (startOfDay(deadline).getTime() - startOfDay(now).getTime()) / 86_400_000,
  );
  if (deadline.getTime() < now.getTime()) {
    return {
      tone: 'danger',
      label: 'Atrasado',
      detail:
        days === 0 ? `corte era ${time(deadline)}` : `corte era ${day(deadline)} ${time(deadline)}`,
    };
  }
  if (days === 0) {
    return {
      tone: 'warning',
      label: `Hoje até ${time(deadline)}`,
      detail: `faltam ${timeLeft(now, deadline)}`,
    };
  }
  if (days === 1) return { tone: 'info', label: `Amanhã até ${time(deadline)}` };
  return { tone: 'neutral', label: `${day(deadline)} até ${time(deadline)}` };
}
